// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"a8735ca8","223":"a8735ca8","230":"6115a820","466":"a8735ca8","537":"6115a820"}[chunkId] + ".chunk.css";
};